// Aadhaar number handling.
//
// There is no API a private pharmacy can legally call to check an Aadhaar
// number against a name and phone. UIDAI authentication is restricted to
// licensed AUA/KUA entities under the Aadhaar Act, and a manufacturer or
// dispensary does not qualify. See the notes in the README for the routes
// that ARE open.
//
// What CAN be done with no licence, no network and no cost is verify the
// number's own check digit. Aadhaar's twelfth digit is a Verhoeff
// checksum, which catches every single-digit error and every transposition
// of adjacent digits -- the two mistakes a person typing from a card
// actually makes.

const D = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
  [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
  [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
  [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
  [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
  [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
  [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
  [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
  [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
]

const P = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
  [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
  [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
  [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
  [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
  [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
  [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
]

/** Digits only, spaces and dashes removed. */
export const normaliseAadhaar = (input: string) => input.replace(/\D/g, '')

/** "1234 5678 9012" -- how it is printed on the card. */
export const formatAadhaar = (input: string) =>
  normaliseAadhaar(input).replace(/(\d{4})(?=\d)/g, '$1 ').trim()

/** Only the last four digits are safe to show. */
export const maskAadhaar = (input: string) => {
  const d = normaliseAadhaar(input)
  return d.length === 12 ? `XXXX XXXX ${d.slice(8)}` : ''
}

export function isValidAadhaar(input: string): boolean {
  const digits = normaliseAadhaar(input)
  if (!/^[2-9]\d{11}$/.test(digits)) return false   // never begins 0 or 1

  let c = 0
  const reversed = digits.split('').reverse().map(Number)
  for (let i = 0; i < reversed.length; i++) {
    c = D[c]![P[i % 8]![reversed[i]!]!]!
  }
  return c === 0
}
